import { render, staticRenderFns } from "./phone-search.vue?vue&type=template&id=b6529d30&scoped=true&"
import script from "./phone-search.vue?vue&type=script&lang=js&"
export * from "./phone-search.vue?vue&type=script&lang=js&"
import style0 from "./phone-search.vue?vue&type=style&index=0&id=b6529d30&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6529d30",
  null
  
)

export default component.exports